import {Component, inject} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {MainMenuComponent} from './components/main-menu/main-menu.component';
import {HeaderComponent} from './components/header/header.component';
import { registerLocaleData } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import localeDe from '@angular/common/locales/de';
import {HttpClient} from '@angular/common/http';
import {ENVIRONMENT} from '../environments/environment';
import {CustomMissingTranslationHandler} from './classes/CustomMissingTranslationHandler.class';

/**
 * Create a custom translation loader
 * @param httpClient
 * @returns {TranslateHttpLoader}
 */
export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, ENVIRONMENT.translation_path, '.json');
}

/**
 * Factory for CustomMissingTranslationHandler
 *
 * @returns {CustomMissingTranslationHandler}
 */
export function createCustomMissingTranslationHandler() {
  return new CustomMissingTranslationHandler();
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MainMenuComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'bandmanager-admin';
  private translateService = inject(TranslateService);

  constructor() {
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');

    registerLocaleData(localeDe);
  }
}
